import { Wrapper, OnBoardingHeader, OnBoardingBody } from './style'
import { useParams } from 'react-router-dom'
import { Link, useLocation } from 'react-router-dom'
import { useTypedSelector } from 'src/redux/index'
import { ModalButton } from 'src/components/Global/Button/Button'

const ContestOnBoarding = () => {
  const params = useParams()
  const { id } = params
  let location = useLocation()
  const allContest = useTypedSelector((state) => state.xcontest.all)
  const singleContest = allContest.filter((item: any) => item?.id === id)
  const data = singleContest[0]

  const {
    image,
    amount_to_save,
    description,
    number_of_members,
    name,
    reward,
    saving_frequency,
  } = data

  return (
    <Wrapper>
      <OnBoardingHeader>
        <img src={image} alt="" className="header_img" />
      </OnBoardingHeader>
      <OnBoardingBody>
        <div className="name_description">
          <h3 className="name">{name}</h3>
          <p className="description">{description}</p>
        </div>
        <div className="details">
          <p>{number_of_members} PEOPLE JOINED</p>
          <p>
            {amount_to_save} <span>{saving_frequency}</span>
          </p>
          <p>{reward}</p>
        </div>
        <div className="btn_wrapper">
          <Link to={`/${id}`} state={{ backgroundLocation: location }}>
            <ModalButton>Join Contest</ModalButton>
          </Link>
        </div>
      </OnBoardingBody>
    </Wrapper>
  )
}

export default ContestOnBoarding
